/**
 *  @class
 *  @function ReturningUserHub
 */
if (!customElements.get('returning-user-hub')) {
  class ReturningUserHub extends HTMLElement {
    constructor() {
      super();
      this.storageKey = 'returning-user-hub-collections';
      this.storageLimit = 6;
    }
    connectedCallback() {
      this.renderLimit = parseInt(this.dataset.collectionsLimit, 10) || 4;
      this.trigger = document.getElementById('ReturningUserHubTrigger');
      this.trackCurrentCollection();
      this.renderCollections();
      this.setupTrigger();
    }
    readCollections() {
      if (!window.localStorage) return [];
      try {
        const stored = JSON.parse(window.localStorage.getItem(this.storageKey));
        return Array.isArray(stored) ? stored : [];
      } catch (e) {
        return [];
      }
    }
    writeCollections(list) {
      if (!window.localStorage) return;
      window.localStorage.setItem(this.storageKey, JSON.stringify(list));
    }
    trackCurrentCollection() {
      const raw = this.dataset.currentCollection;
      if (!raw) return;
      let current;
      try {
        current = JSON.parse(raw);
      } catch (e) {
        return;
      }
      if (!current || !current.handle) return;

      const list = this.readCollections().filter((item) => item.handle !== current.handle);
      list.unshift(current);
      this.writeCollections(list.slice(0, this.storageLimit));
    }
    escapeHtml(value) {
      return String(value == null ? '' : value).replace(/[&<>"']/g, (char) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[char]));
    }
    renderCollections() {
      const wrapper = this.querySelector('[data-visited-collections-wrapper]');
      const list = this.querySelector('[data-visited-collections-list]');
      if (!wrapper || !list) return;

      const collections = this.readCollections().slice(0, this.renderLimit);
      if (!collections.length) {
        wrapper.hidden = true;
        return;
      }

      list.innerHTML = collections.map((item) => (
        '<li class="returning-user-hub-collections--item">' +
          `<a href="${this.escapeHtml(item.url)}" class="returning-user-hub-collections--link">` +
            (item.image
              ? `<span class="returning-user-hub-collections--image"><img src="${this.escapeHtml(item.image)}" alt="" width="40" height="40" loading="lazy"></span>`
              : '') +
            `<span class="returning-user-hub-collections--title">${this.escapeHtml(item.title)}</span>` +
            '<span class="returning-user-hub-collections--arrow" aria-hidden="true"><svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L5 5L1 9" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
          '</a>' +
        '</li>'
      )).join('');

      wrapper.hidden = false;
    }
    isReturningVisitor() {
      if (document.body.classList.contains('customer-logged-in')) return true;
      if (this.readCollections().length) return true;
      if (window.localStorage) {
        try {
          const viewed = JSON.parse(window.localStorage.getItem('recently-viewed'));
          if (Array.isArray(viewed) && viewed.length) return true;
        } catch (e) {
          // ignore malformed storage
        }
      }
      return false;
    }
    setupTrigger() {
      if (!this.trigger) return;
      if (this.isReturningVisitor()) {
        this.trigger.hidden = false;
        this.trigger.classList.add('is-visible');
      }
      this.trigger.addEventListener('click', () => {
        OverlayManager.open(this);
      });
    }
  }
  customElements.define('returning-user-hub', ReturningUserHub);
}
